/*
 * Created by jmeo at 2021-06-02
 * FileName: Entrust.tsx
 * 委托担保申请书
 */

import {setTitle} from "@src/util";
import CustomScroll from '@src/component/customScroll'
export default function () {
    setTitle('委托担保申请书')
    return <div className="page bottomFit"><CustomScroll><div className="agreement">
        <h2>委托担保申请书</h2>
        <p>深圳市华融融资担保有限公司：</p>
        <p>兹有本人拟通过向具备贷款资质的贷款人申请贷款，具体贷款金额以贷款人实际贷款金额为准，特此向贵司申请为上述贷款提供委托担保服务。本人已仔细阅读本委托担保申请书中的所有条款，并已特别注意字体加黑的意义以及由此产生的法律效力,自愿作出上述委托担保申请，本人对所有条款的含义及相应的法律后果已全部通晓并充分理解,自愿作出上述申请、承诺和声明，同意承担由此带来的一切法律后果,同意受此约束。</p>
        <p><strong>一、本人承诺担保申请是本人真实自愿之意思表示，已确认并知悉申请事项及内容。</strong> </p>
        <p><strong>二、本人知悉贵司有权基于贵司内部风控合规制度及本人信用信息情况作出接受委托提供担保或拒绝接受委托担保的决定，本人承诺尊重贵司决定。若贵司同意提供担保服务，本人知悉并同意与贵司签署《委托担保合同》，具体以实际签署的合同为准。</strong> </p>
        <p>三、为便于贵司了解本人信用状况，作出是否提供担保之决定，<strong>本人承诺向贵司出具《个人征信查询授权书》，授权贵司按照国家相关规定采集并向金融信用信息基础数据库及其他依法成立的征信机构提供本人个人信息和包括信贷信息在内的信用信息</strong>（包含本人因未及时履行合同义务产生的不良信息）。其余授权以本人向贵司出具的《个人征信查询授权书》内容为准。</p>
        <p><strong>四、本人授权并委托贵司将根据委托担保申请书取得的本人的信用信息提供给贷款人及服务方，以用于本人的贷款及服务资格审核，贵司向贷款人及服务方提供本人信用信息的行为视为本人向其提供该等信息。</strong></p>
        <p><strong>五、本人知悉并同意承担因向贷款人及服务方提供本人信用信息而可能产生的不利后果，且自愿承担。</strong></p>
        <p><strong>六、如贷款人及/或服务方超出授权范围或以其他非法方式使用本人信用信息，由贷款人及/或服务方承担相关法律责任,与贵司无关。</strong></p>
        <p><strong>七、本申请书自本人签字、采用电子签名方式签署或以其他方式确认之日起即生效，有效期至本人债务结清且贵司担保责任解除之日止。</strong></p>
        <br/>
    </div></CustomScroll></div>
}